var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('button',{staticClass:"btn",on:{"click":_vm.onCreateNewProject}},[_vm._v(" Add custom selection ")])])}
var staticRenderFns = []

export { render, staticRenderFns }